import { http } from './config'

export default {
  
  getAllCompatibilities: (productGroupId) => {
    return http.get('product_groups/' + productGroupId + '/compatibilities')
  },

  createCompatibility: (compatibilitiesParams) => {
    return http.post('compatibilities', {
      compatibility_sequence: compatibilitiesParams.compatibility_sequence,
      product_group_id: compatibilitiesParams.product_group_id,
      compatible_product_group_id: compatibilitiesParams.compatible_product_group.id
    })
  },

  getCompatibilityById: (compatibilityId) => {
    return http.get('compatibilities/' + compatibilityId)
  },

  updateCompatibility: (compatibilitiesParams) => {
    return http.put('compatibilities/' + compatibilitiesParams.compatibilityId, {
      compatibility_sequence: compatibilitiesParams.compatibility_sequence,
      product_group_id: compatibilitiesParams.product_group_id,
      compatible_product_group_id: compatibilitiesParams.compatible_product_group.id
    })
  },
  
  saveSequence: (compatibility_sequence, compatibilityId) => {
    return http.put('compatibilities/' + compatibilityId + '/sequence_compatibility', {
      compatibility_sequence: compatibility_sequence,
    })
  },

  deleteCompatibility: (compatibilityId) => {
    return http.delete('compatibilities/' + compatibilityId)
  },

}
